import tinycolor from 'tinycolor2';

import Element from './abstract/element';
import ShapeGetter from './shape';
import TextGetter from './text';

module.exports = Sticker;

function Sticker () {}

Sticker.prototype = new Element();
Sticker.prototype.constructor = Sticker;

Sticker.prototype.initialize = function () {
  Element.prototype.initialize.call(this);

  this.supportedSubElements = ['image', 'ellipse', 'line', 'rect', 'text', 'polygon', 'circle', 'ellipse', 'path', 'g'];
  this.structure = _.extend(this.structure, {
    placeholder: null,
    banner: null,
    texts: [{
      id: null,
      content: null,
      decoration: null,
      color: null,
      anchor: null,
      font: {
        family: null,
        weight: null,
        style: null
      }
    }],
    shapes: [{
      id: null,
      type: null,
      fill: {
        color: null,
        colorGroup: null
      },
      stroke: {
        color: null,
        width: null,
        dasharray: null
      }
    }]
  });
};

Sticker.prototype.get = function (element) {
  const result = Element.prototype.get.apply(this, arguments);

  if (result.id && !result.thumb_src) {
    result.thumb_src = element.getAttribute('data-thumb-src');
  }

  return result;
};

Sticker.prototype.getTexts = function () {
  return _.map($(this.element).find('.textarea'), function (text) {
    const textGetter = new TextGetter();
    textGetter.element = text;
    textGetter.textarea = new INKIVE.Text.Textarea().setDOM(text);
    textGetter.text = textGetter.textarea.text;

    return textGetter;
  });
};

Sticker.prototype.getShapes = function () {
  const shapes = {};

  _.each(this.getElements(), function (elem, index) {
    shapes[index] = new ShapeGetter();
    shapes[index].element = elem;
  });

  return shapes;
};

Sticker.prototype.getElementsWithColor = function (element) {
  element = element || this.element;

  const result = {};
  const defaultFillTypes = ['path', 'line', 'polygon', 'rect', 'circle', 'ellipse'];

  _.each(this.getElements(element), checkForColor);

  return result;

  function checkForColor (elem, index) {
    const parentGroup = $(elem).closest('g')[0];

    const inheritFillColor = parentGroup &&
      $.contains(parentGroup, elem) &&
      parentGroup.getAttribute('fill');

    const hasAutomaticColor = !inheritFillColor &&
      _.contains(defaultFillTypes, elem.tagName);

    if (elem.getAttribute('fill') || elem.getAttribute('stroke') || hasAutomaticColor) {
      result[index] = elem;
    }
  }
};

Sticker.prototype.getElementsByColorGroup = function (elements, shape) {
  const { colorGroup, previousColor } = shape;

  return elements.reduce((acc, target) => {
    const attributeColor = target.getAttribute('fill') || target.getAttribute('stroke');

    if (
      !(
        isAllowedFillTypes(target) &&
        isTheSameColor(attributeColor, previousColor) &&
        isTheSameColorGroup(target, colorGroup))
    ) {
      return acc;
    } else if (target.dataset.colorGroup === undefined) {
      target.dataset.colorGroup = colorGroup;
    }

    return acc.concat(target);
  }, []);

  function isAllowedFillTypes (target) {
    const allowedTypes = ['path', 'line', 'polygon', 'rect', 'circle', 'ellipse'];

    if (allowedTypes.includes(target.tagName)) return true;
    if (target.tagName === 'g') {
      return target && !target.querySelector('[fill]');
    }

    return false;
  }

  function isTheSameColor (color, previousColor) {
    return color && tinycolor(color).toString() === tinycolor(previousColor).toString();
  }

  function isTheSameColorGroup (target, colorGroup) {
    return !target.dataset.colorGroup || target.dataset.colorGroup === String(colorGroup);
  }
};

Sticker.prototype.getElements = function (element) {
  element = element || this.element;

  return [...element.children].reduce((subElements, child) => {
    const isBackground = child.classList.contains('rect.background');
    const isGroup = child.tagName === 'g';
    const isTextArea = child.classList.contains('textarea');
    const supported = this.supportedSubElements.includes(child.tagName);

    if (supported) {
      if (isGroup && !isTextArea) return [...subElements, ...this.getElements(child)];
      else if (!isBackground) return [...subElements, child];
    }

    return subElements;
  }, [element]);
};

Sticker.prototype.getPlaceholder = function (element) {
  element = element || this.element;
  return element.classList.contains('placeholder-frame');
};

Sticker.prototype.getBanner = function (element) {
  element = element || this.element;
  return element.classList.contains('text-banner');
};
